export default "__VITE_ASSET__KoCCqLYv__"